module.exports = __webpack_public_path__ + "img/industry_solution4.d1a7fe88.png";